import { PollCursor } from '../../_utils/poll-cursor.util'

export interface PresencePollResponse {
  data: {
    sites: any
    presence?: any
    sessions: any
    users: any
  }
  cursor?: PollCursor
  backfilling: boolean
  id: number
  done: boolean
}

export interface PresencePollErrorResponse {
  text: string
}

export enum PresencePollRequestType {
  Signin = 1,
  TokenRefresh = 2,
  ForcePoll = 3,
  Signout = 4,
  Backfill = 5,
}

export enum PresencePollResponseType {
  Poll = 1,
  TokenRefresh = 2,
  Error = 3,
  ConnectionOk = 4,
  ConnectionError = 5,
}
